import { render } from "./AppointmentForm.vue?vue&type=template&id=f93b6b1c&scoped=true&ts=true"
import script from "./AppointmentForm.vue?vue&type=script&lang=ts"
export * from "./AppointmentForm.vue?vue&type=script&lang=ts"

import "./AppointmentForm.vue?vue&type=style&index=0&id=f93b6b1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f93b6b1c"]])

export default __exports__